import { AbstractControl, ValidatorFn } from '@angular/forms';

export class DateValidators {
    static dateLessThan(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date1 = c.get(dateField1).value;
            const date2 = c.get(dateField2).value;
            if ((date1 !== null && date2 !== null)) {
                let d1 = new Date(date1);
                let d2 = new Date(date2);
                if(d1 > d2){
                    return validatorField;
                }
                return null;
            }
            return null;
        };
    }
}